function matchBarCode(modelData, barCode) {
    // tvModelsJson: tvModel;eanCode;manufacturer;feature_sat;feature_ip
    return modelData.find((tv) => tv.eanCode === barCode);
}

export { matchBarCode };
